import { ArrowRight, MessageCircle } from "lucide-react";
import { motion } from "framer-motion";
import { ASSETS } from "../lib/assets";

export const Founder = () => {
  const go = (id) =>
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <section
      id="founder"
      data-testid="founder-section"
      className="relative py-24 lg:py-32 border-t border-white/5 overflow-hidden"
    >
      <div className="absolute -left-40 top-1/2 -translate-y-1/2 w-[500px] h-[500px] rounded-full bg-[rgba(182,245,0,0.06)] blur-3xl" />

      <div className="relative max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        {/* IMAGE */}
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="relative"
          data-testid="founder-image"
        >
          <div className="absolute -inset-4 rounded-3xl border border-[rgba(182,245,0,0.3)]" />
          <div className="relative rounded-2xl overflow-hidden border border-[rgba(182,245,0,0.5)] lime-glow">
            <img
              src={ASSETS.founder}
              alt="Stavan Bhore"
              className="w-full h-[560px] sm:h-[620px] object-cover object-[center_22%]"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent" />
          </div>
          <div className="absolute -bottom-4 -right-4 bg-[rgb(182,245,0)] rounded-2xl px-5 py-3 flex items-center gap-2 shadow-2xl">
            <span className="text-black font-display font-bold text-sm">
              ★ Founder & Builder
            </span>
          </div>
        </motion.div>

        {/* CONTENT */}
        <motion.div
          initial={{ opacity: 0, x: 30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
        >
          <div className="text-xs sm:text-sm tracking-[0.4em] text-[rgb(182,245,0)] font-mono-alt uppercase mb-4">
            Meet the Founder
          </div>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-2">
            Stavan Bhore
          </h2>
          <div className="text-[rgb(182,245,0)] font-display text-xl sm:text-2xl font-semibold mb-7">
            Founder & Web Developer
          </div>

          <p className="text-white/65 text-base sm:text-lg leading-relaxed mb-5">
            A passionate web designer and developer focused on building modern,
            high-performance websites that help businesses grow online. Focused
            on clean UI, smooth user experience, and strong digital presence.
          </p>
          <p className="text-white/65 text-base sm:text-lg leading-relaxed mb-9">
            Every project is designed with attention to detail, performance,
            and scalability to ensure long-term success for clients. The goal
            is to deliver professional, modern, and business-focused websites
            that create real impact.
          </p>

          <div className="flex flex-wrap gap-4">
            <button
              data-testid="founder-view-services-btn"
              onClick={() => go("services")}
              className="btn-lime px-6 py-3 rounded-full font-semibold inline-flex items-center gap-2 text-sm"
            >
              View My Work <ArrowRight className="w-4 h-4" />
            </button>
            <button
              data-testid="founder-contact-btn"
              onClick={() => go("contact")}
              className="btn-ghost px-6 py-3 rounded-full inline-flex items-center gap-2 text-sm"
            >
              <MessageCircle className="w-4 h-4" /> Get In Touch
            </button>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
